import BookingRepository, { IBookingRepository } from '@/services/booking/BookingRepository'
import { ScorePayload } from '@/types'

export class BookingService {
  private repository: IBookingRepository

  constructor() {
    this.repository = new BookingRepository('bookings')
  }

  async getBooking(id: string, type: string, language?: string): Promise<any> {
    const { data } = await this.repository.getBooking(id, type, language)

    return data
  }

  async createScore(bookingId: string, payload: ScorePayload): Promise<any> {
    await this.repository.createScore(bookingId, payload)
  }
}

export default new BookingService()
